import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { ArrowDownIcon, ArrowUpIcon } from '@mentimeter/ragnar-visuals';

interface QfaNavigationButtonProps {
  isDisabled: boolean;
  onClick: () => void;
  direction: 'up' | 'down';
}

export const QfaNavigationButton = ({
  isDisabled,
  onClick,
  direction,
}: QfaNavigationButtonProps) => {
  return (
    <Clickable
      aria-label="Next question"
      disabled={isDisabled}
      borderRadius="full"
      onClick={onClick}
      mb={3}
      bg="surfaceOverlayTransparent"
      p="space4"
      extend={() => ({
        visibility: isDisabled ? 'hidden' : 'visible',
      })}
    >
      {direction === 'up' ? (
        <ArrowUpIcon size={3} color="text" />
      ) : (
        <ArrowDownIcon size={3} color="text" />
      )}
    </Clickable>
  );
};
